import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectCashierConfiguration } from '@cashier/cashier-data-access';
import { TaxConfiguration } from '@cashier/cashier-model';
import { getCurrencySymbol } from '@cashier/cashier-shared';

const DEFAULT_TAX_AMOUNT = '0';

interface UseTaxInformation {
  taxAmount: string;
  currencySymbol: string | null;
}

export const useTaxInformation = (
  taxConfiguration: TaxConfiguration,
): UseTaxInformation => {
  const { currency } = useSelector(selectCashierConfiguration);

  const amount = ''; //TODO: temporary code due to new payload structure

  const taxAmount = useMemo(() => {
    if (!amount) {
      return DEFAULT_TAX_AMOUNT;
    }

    /* TODO: there should be separated calculations for each type of taxConfig (for now its only GHA)  */
    const { deductibleStake, taxPercentage } = taxConfiguration;

    if (Number(amount) < Number(deductibleStake)) {
      return DEFAULT_TAX_AMOUNT;
    }

    const calculatedTax =
      ((Number(amount) - Number(deductibleStake)) * Number(taxPercentage)) /
      100;

    return calculatedTax.toFixed(2);
  }, [amount, taxConfiguration]);

  return {
    taxAmount,
    currencySymbol: getCurrencySymbol(currency),
  };
};
